
//API Endpoints
export const API_URL = "/giftcard/v1/";

// Local storage
export const LOCALSTORAGE_KEY_BASKET_ID = "giftcard-basket-id";

export const LOCALSTORAGE_KEY_ACTIVATE_BASKET_ID = "activate-basket-id";

export const PERSONAL_MESSAGE_MAX_LENGTH = 1000;

// Page Links aliases
export const PAGE_LINKS = {
    BENEFITS: "benefits-page",
    BUY_GIFT_CARD: "buy-gift-card-page",
    BUY_GIFT_CARD_CONFIRMATION: "buy-gift-card-confirmation-page",
    CATALOGUE: "catalogue-page",
    CONTACT: "contact-page",
    PRIVACY: "privacy-page",
    REGIFT: "regift-page",
    REGIFT_CONFIRMATION: "regift-confirmation-page",
    TERMS: "terms-page",
    REDEEM_CODE: "redeem-code"
};

export type PhoneValidationRegexKeys = keyof typeof PHONE_NUMBER.VALIDATIONS.REGEX;
export type PhoneCountryCodeKeys = keyof typeof PHONE_NUMBER.COUNTRIES;
export const PHONE_NUMBER = {
    VALIDATIONS: {
        MAXLENGTH: 16,
        REGEX: {
            IE: /^\+3538\d{8}$/,
            GB: /^\+447\d{9}$/
        }
    },
    COUNTRIES: {
        IE: "+353",
        GB: "+44"
    },
    DEFAULT_COUNTRY: "IE"
};